<script setup>
// 第三方库
import { ref, reactive, nextTick, onMounted } from 'vue'
import { Overlay } from 'vant'
import html2canvas from 'html2canvas'
// 请求
import request from '@/utils/request'
// 自定义
import { isWeixinBrowser, showDownloadBtn, wxShare, isMoible } from '@/utils/common.js'

onMounted(() => {
  getNewsList()
})

// 是否是微信设备
const isWeixin = isWeixinBrowser()

if (!isMoible() && !isWeixin) {
  window.location.href = 'https://static.medsci.cn/product/medsci/active/hot/index.html#/news'
}

// 新闻描述隐藏
// const showDesc = ref(false)

// 微信分享配置
wxShare({
  title: '梅斯医学新闻快讯',
  summary: '最新资讯，一手掌握，尽在梅斯医学APP！',
  thumb: 'https://static.medsci.cn/public-image/ms-image/ea747d00-6d40-11ec-8e2f-1389d01aad85_icon_share.png',
  link: 'https://static.medsci.cn/product/medsci/active/hot/index.html#/news_m'
})

// 遮罩层
const showOverlay = ref(false)
const isShowPoster = ref(false)
const handleOverlayClose = () => {
  showOverlay.value = false
  isShowPoster.value = false
  showBgImg.value = false
}

// 截图分享
const showBgImg = ref(false)
const imageWrapper = ref(null)
const posterUrl = ref(null)
const screenshotTitle = ref('')
const screenshotContent = ref('')
const screenshotTime = ref('')
const showPoster = async (item) => {
  screenshotTitle.value = item.title
  screenshotContent.value = item.body
  screenshotTime.value = item.pub_time.substring(12, 16)

  showOverlay.value = true
  isShowPoster.value = true
  await nextTick()
  html2canvas(imageWrapper.value, {
    allowTaint: false,
    useCORS: true,
    height: imageWrapper.value.offsetHeight, // 下面解决当页面滚动之后生成图片出现白边问题
    width: imageWrapper.value.offsetWidth,
    windowWidth: document.body.scrollWidth,
    windowHeight: document.body.scrollHeight,
    x: 0,
    y: 0,
    dpi: 350, // 解决图片不清晰问题
    scale: 2
  }).then(function (canvas) {
    posterUrl.value = canvas.toDataURL('image/png')
    showBgImg.value = true
  })
  // setTimeout(() => {

  // }, 1000)
}

// 获取新闻列表
const newsList = reactive([])
const getNewsList = async () => {
  const { data } = await request.get('/activity/system/hotspot-ranking')
  newsList.length = 0
  newsList.push(...data.reverse())
}
</script>

<template>
  <div class="container">
    <!-- 主要内容 -->
    <main>
      <h1 class="title">今天</h1>
      <ul class="newsList">
        <li v-for="item in newsList" :key="item.id">
          <h2>{{ item.title }}</h2>
          <p class="time">{{ item.pub_time.substring(10, 16) }}</p>
          <transition name="van-fade">
            <p class="desc" v-show="item.show" v-html="item.artsummary"></p>
          </transition>
          <div class="menu">
            <span v-if="item.show" @click="item.show = !item.show">
              收起
              <span class="iconfont icon-xiangshangjiantou"></span>
            </span>
            <span v-else @click="item.show = !item.show">
              展开
              <span class="iconfont icon-xiangxiajiantou"></span>
            </span>
            <div class="tool">
              <!--<a href="https://www.medsci.cn/guideline/show_article.do?id=9e8971c0023105fc#commentAvatar">
                <img src="https://static.medsci.cn/public-image/ms-image/b8401690-6d28-11ec-8e2f-1389d01aad85_icon_1.png" />
              </a>-->
              <img
                @click="showPoster(item)"
                v-if="isWeixin"
                src="https://static.medsci.cn/public-image/ms-image/b8401690-6d28-11ec-8e2f-1389d01aad85_icon_2.png"
              />
              <img
                @click="showPoster(item)"
                v-if="isWeixin"
                src="https://static.medsci.cn/public-image/ms-image/b8401690-6d28-11ec-8e2f-1389d01aad85_icon_3.png"
              />
            </div>
          </div>
        </li>
        <!--<li>
          <h2>如何看待《2021中国城市租住生活蓝皮书称10年内超2亿国人要租房？</h2>
          <p class="time">09:35</p>
          <transition name="van-fade">
            <p class="desc" v-show="showDesc">
              12月22日0-24时，浙江新增确诊病例2例，其中绍兴市1例（集中隔离点检测发现）、境外输入1例（为之前埃塞俄比亚输入的无症状感染者转确诊），已排查密切接触者均已实施集中隔离。截至22日24时，累计报告确诊病例2001例（境外输入病例292例）。（健康浙江）
              <a href="https://www.medsci.cn/guideline/show_article.do?id=9e8971c0023105fc">
                <img src="https://static.medsci.cn/public-image/ms-image/063cfad0-6d00-11ec-8e2f-1389d01aad85_view_detail.png" />
              </a>
            </p>
          </transition>
          <div class="menu">
            <span v-if="showDesc" @click="showDesc = !showDesc">
              收起
              <span class="iconfont icon-xiangshangjiantou"></span>
            </span>
            <span v-else @click="showDesc = !showDesc">
              展开
              <span class="iconfont icon-xiangxiajiantou"></span>
            </span>
            <div class="tool">
              <a href="https://www.medsci.cn/guideline/show_article.do?id=9e8971c0023105fc#commentAvatar">
                <img src="https://static.medsci.cn/public-image/ms-image/b8401690-6d28-11ec-8e2f-1389d01aad85_icon_1.png" />
              </a>
              <img
                v-if="isWeixin"
                src="https://static.medsci.cn/public-image/ms-image/b8401690-6d28-11ec-8e2f-1389d01aad85_icon_2.png"
              />
              <img
                v-if="isWeixin"
                src="https://static.medsci.cn/public-image/ms-image/b8401690-6d28-11ec-8e2f-1389d01aad85_icon_3.png"
              />
            </div>
          </div>
        </li>-->
      </ul>
    </main>
    <!-- app下载提示栏 -->
    <section class="appDownloadTip" v-if="showDownloadBtn()">
      <div class="app">
        <img src="https://static.medsci.cn/public-image/ms-image/9202d670-6873-11ec-8e2f-1389d01aad85_app_icon.png" />
        <div class="info">
          <p>梅斯医学MedSci APP</p>
          <span>医路相伴，成就大医</span>
        </div>
      </div>
      <a href="https://a.app.qq.com/o/simple.jsp?pkgname=cn.medsci.app.news">打开</a>
    </section>
    <!-- 遮罩层 -->
    <Overlay :show="showOverlay" @click="handleOverlayClose" />
    <!-- 海报 -->
    <section class="poster" v-show="isShowPoster">
      <!-- 要生成图片的DIV -->
      <div class="bg" ref="imageWrapper">
        <!--<img class="bg" src="https://static.medsci.cn/public-image/ms-image/0c67a9c0-6df8-11ec-8e2f-1389d01aad85_bg.png" />-->
        <img class="bg" src="https://static.medsci.cn/public-image/ms-image/72f945c0-af31-11ec-a1b8-6123b3ff61ea_1.png" />
        <div class="content">
          <p class="time">
            <img src="https://static.medsci.cn/public-image/ms-image/ffa68440-6dd4-11ec-8e2f-1389d01aad85_icon_info.png" />
            <span>今天 {{ screenshotTime }}</span>
          </p>
          <p class="title">{{ screenshotTitle }}</p>
          <p class="desc" v-html="screenshotContent"></p>
        </div>
        <!--<img
          class="qrcode"
          src="https://static.medsci.cn/public-image/ms-image/0c67a9c0-6df8-11ec-8e2f-1389d01aad85_qrcode.png"
        />-->
      </div>
      <img class="bg_img" :src="posterUrl" v-show="showBgImg" />
      <div class="tooltip">
        <img
          src="https://static.medsci.cn/public-image/ms-image/ac06cf90-6dd2-11ec-8e2f-1389d01aad85_finger.png"
          style="width: 19.26px; height: 18.69px"
        />
        <span>长按海报保存后分享</span>
      </div>
    </section>
  </div>
</template>
<style lang="less" scoped>
@import url('index.less');
</style>
